import React, { useRef, useEffect } from "react";

function AdVideoCard({ ad, isActive, onActivate, onDeactivate }) {
  const videoRef = useRef(null);
  const cardRef = useRef(null);

  //  user tap (on sound toggle)
  const handleVideoClick = () => {
    if (isActive) {
      onDeactivate();
      if (videoRef.current) videoRef.current.muted = true;
    } else {
      onActivate(ad.id);
      if (videoRef.current) {
        videoRef.current.muted = false;
        videoRef.current.play().catch(() => {});
      }
    }
  };

  // play the video when it’s visible, muted by default
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!videoRef.current) return;

        if (entry.isIntersecting) {
          // ensure it’s playing (muted by default)
          videoRef.current.play().catch(() => {});
          if (!isActive) videoRef.current.muted = true;
        } else {
          // when it leaves view, mute
          videoRef.current.muted = true;
        }
      },
      { threshold: 0.3 }
    );

    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, [isActive]);

  // Handle activation (for when other videos deactivate this one)
  useEffect(() => {
    if (!videoRef.current) return;

    if (isActive) {
      videoRef.current.muted = false;
      videoRef.current.play().catch(() => {});
    } else {
      videoRef.current.muted = true;
    }
  }, [isActive]);

  return (
    
    <div
      ref={cardRef}
      className="ad-card-inner"   // NEW CLASS

      onClick={handleVideoClick}
      style={{ cursor: "pointer" }}
      >
    
      <video
        ref={videoRef}
        src={ad.url}
        autoPlay
        loop
        muted
        playsInline
        controls={false}
        className="ad-video"
      />
    
</div>
    
  );
}

export default AdVideoCard;
